import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Disclaimer = () => {
  return (
    <Paper 
      elevation={0}
      sx={{
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        p: 2,
        mt: 'auto'
      }}
    >
      <Box sx={{ maxWidth: '100%', mx: 'auto' }}>
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ 
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            lineHeight: 1.4,
            textAlign: 'left',
            mb: 2
          }}
        >
          The content on this website is for informational and entertainment purposes only and should not be considered advice, encouragement, or an offer to engage in gambling, sports betting, or wagering.
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ 
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            lineHeight: 1.4,
            textAlign: 'left',
            mb: 2
          }}
        >
          Users are responsible for complying with all applicable sports betting laws in their jurisdiction. We make no representations or warranties regarding the legality of any activities mentioned.
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ 
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            lineHeight: 1.4,
            textAlign: 'left',
            mb: 2
          }}
        >
          This website is not affiliated with, endorsed by, or sponsored by any professional sports league, team, or organization, including but not limited to the NFL, MLB, NBA, NHL, PGA, UFC, and WNBA. All trademarks, logos, and images are the property of their respective owners, and their use does not imply any association or endorsement.
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ 
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            lineHeight: 1.4,
            textAlign: 'left',
            fontWeight: 500
          }}
        >
          If you or someone you know is struggling with a gambling problem, help is available. Call the confidential 24/7 helpline at{' '}
          <Typography 
            component="span" 
            sx={{ 
              fontWeight: 600,
              color: 'primary.main'
            }}
          >
            877-718-5543
          </Typography>
          {' '}for support and resources.
        </Typography>
      </Box>
    </Paper>
  );
};

export default Disclaimer;